export default __webpack_public_path__ + "static/media/ic_menu_timekeeping.cb4ae6b8.svg";